import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'

import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
import VuetifyMoney from 'vuetify-money'

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.use(VuetifyMoney)

new Vue({
  router,
  store,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
